import { jsx } from 'react/jsx-runtime';
import { ChevronLeftIcon, ChevronRightIcon } from '@flex-design-system/legacy-flex-icons';
import classNames from 'classnames';
import { IconButton } from '../../../button/icon-button/IconButton.mjs';
import { Flex } from '../../../layout/Flex.mjs';
import { Typography } from '../../../typography/Typography.mjs';
import { header, headerDateText, headerIcon, headerIconButton } from '../../datePicker.vanilla.mjs';

function CalendarHeader({ children, className, ...props }) {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      align: "center",
      justify: "between",
      className: classNames(header, className),
      ...props,
      children
    }
  );
}
function CalendarHeaderDateText({
  children,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      weight: 600,
      color: "grayDark",
      className: classNames(headerDateText, className),
      ...props,
      children
    }
  );
}
function CalendarHeaderLeftSlot({ children }) {
  return /* @__PURE__ */ jsx(Flex, { align: "center", children });
}
function CalendarHeaderRightSlot({ children }) {
  return /* @__PURE__ */ jsx(Flex, { align: "center", children });
}
function CalendarHeaderPrevIconButton({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      size: "small",
      variant: "ghost",
      className: classNames(headerIconButton, className),
      icon: /* @__PURE__ */ jsx(ChevronLeftIcon, { className: headerIcon, color: "grayLight" }),
      ...props
    }
  );
}
function CalendarHeaderNextIconButton({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      size: "small",
      variant: "ghost",
      className: classNames(headerIconButton, className),
      icon: /* @__PURE__ */ jsx(ChevronRightIcon, { className: headerIcon, color: "grayLight" }),
      ...props
    }
  );
}
CalendarHeader.DateText = CalendarHeaderDateText;
CalendarHeader.LeftSlot = CalendarHeaderLeftSlot;
CalendarHeader.RightSlot = CalendarHeaderRightSlot;
CalendarHeader.PrevIconButton = CalendarHeaderPrevIconButton;
CalendarHeader.NextIconButton = CalendarHeaderNextIconButton;

export { CalendarHeader as default };
//# sourceMappingURL=CalendarHeader.mjs.map
